import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const IndyRacing = () => {
  return (
    <SportsLayoutComp name={'Indy Racing'}/>
  )
}

export default IndyRacing